/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
// すべての.color-swatch__item要素を取得
// const colorSwatches = document.querySelectorAll('.color-swatch__item');

// // 各要素にクリックイベントリスナーを追加
// colorSwatches.forEach((swatch, index) => {
//   swatch.addEventListener('click', () => {
//     // data-color-number属性の値を取得
//     const colorNumber = swatch.getAttribute('data-color-number');
    
//     console.log(`data-color-number: ${colorNumber}`);
//   });
// });

//アコーディオン
// アニメーション関数
const closingAnim = (content, element) => gsap.to(content, {
  height: 0,
  opacity: 0,
  duration: 0.4,
  ease: "power3.out",
  overwrite: true,
  onComplete: () => {
    element.removeAttribute("open");
  },
});

const openingAnim = (content) => gsap.fromTo(
  content,
  { height: 0, opacity: 0 },
  {
    height: "auto",
    opacity: 1,
    duration: 0.4,
    ease: "power3.out",
    overwrite: true,
  }
);

document.addEventListener('DOMContentLoaded', () => {
  // すべての商品アイテムを取得
  const productItems = document.querySelectorAll('.product-item');

  productItems.forEach(productItem => {
    const colorSwatches = productItem.querySelectorAll('.color-swatch__item');
    const progressBar = productItem.querySelector('.color-progress-item');

    if (!progressBar) {
      return;
    }

    // 合計の色数を取得（--colorCount変数から）
    const totalColors = parseInt(productItem.style.getPropertyValue('--colorCount')) || colorSwatches.length || 1;

    // 各スウォッチにクリックイベントリスナーを追加
    colorSwatches.forEach((swatch, index) => {
      swatch.addEventListener('click', () => {
        // data-color-number属性の値を取得
        const colorNumber = parseInt(swatch.getAttribute('data-color-number')) || index + 1;

        // プログレスバーの幅を更新
        const progressWidth = totalColors > 0 ? (colorNumber / totalColors) * 100 : 0;

        if (!isNaN(progressWidth)) {
          progressBar.style.width = `${progressWidth}%`;
        }
      });
    });
  });
});

// JavaScriptコード
// document.querySelectorAll('.cfcl_acc_title').forEach(function(title) {
//   title.addEventListener('click', function() {
//     // `cfcl_close`クラスをトグル
//     this.classList.toggle('cfcl_close');
    
//     // `cfcl_acc_inner`要素の表示をトグル
//     const inner = this.nextElementSibling;
//     if (inner.style.display === 'block') {
//       inner.style.display = 'none';
//     } else {
//       inner.style.display = 'block';
//     }
//   });
// });
// フッターアコーディオンの機能を実装
document.addEventListener('DOMContentLoaded', () => {
  const footerItems = document.querySelectorAll('.footer__item--links');
  const mobileBreakpoint = 999;

  function setupAccordion() {
    const isMobile = window.innerWidth <= mobileBreakpoint;

    footerItems.forEach(item => {
      const title = item.querySelector('.footer__item-title');
      const content = item.querySelector('.footer__item-content');

      if (isMobile) {
        // モバイル表示時の処理
        title.addEventListener('click', handleClick);
        item.removeAttribute('open');
        gsap.set(content, { height: 0, opacity: 0 });
      } else {
        // デスクトップ表示時の処理
        title.removeEventListener('click', handleClick);
        item.setAttribute('open', '');
        gsap.set(content, { height: 'auto', opacity: 1 });
      }
    });
  }

  function handleClick(e) {
    e.preventDefault();
    const item = e.target.closest('.footer__item--links');
    const content = item.querySelector('.footer__item-content');

    if (item.hasAttribute('open')) {
      closingAnim(content, item);
    } else {
      item.setAttribute('open', '');
      openingAnim(content);
    }
  }

  // 初期設定
  setupAccordion();

  // ウィンドウリサイズ時に再設定
  window.addEventListener('resize', setupAccordion);
});

if (document.querySelector('.js-changeSizeGuide')) {
  const checkExitSizeGuide = setInterval(function() {
    const elements = document.querySelector('div[data-app="eastsideco_sizeGuides"] a');
    if (elements) {
      clearInterval(checkExitSizeGuide);
      const size_guide = document.querySelector('.js-changeSizeGuide');
      size_guide.removeAttribute("hidden");
      size_guide.addEventListener("click", function() {
          elements.click();
      });
      
      
    }
  }, 100); // check every 100ms
}

//アニメーション
document.addEventListener('DOMContentLoaded', function() {
  //フェードイン
  gsap.utils.toArray('.js-fadeIn').forEach((element, index) => {
    gsap.fromTo(element, 
      {
        opacity: 0,
        filter: 'blur(5px)',
        y: 20
      },
      {
        opacity: 1,
        filter: 'blur(0px)',
        y: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=100',
          toggleActions: 'play none none none'
        },
        // stagger: {
        //   amount: 0.3,
        //   from: "start",
        //   ease: "power2.in"
        // }
      }
    );
  });
  
  //フェードイン2
  gsap.utils.toArray('.slideshow__slide-list').forEach((element, index) => {
    gsap.fromTo(element, 
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=100',
          toggleActions: 'play none none none'
        },
      }
    );
  });
});

//スクロール判定
window.addEventListener('DOMContentLoaded', function() {
  gsap.to('.shopify-section--header', {
    ease: 'none',
    scrollTrigger: {
      trigger: 'body',
      start: 'top top',
      end: 'bottom top',
      toggleClass: {
        targets:'body',
        className: 'is-scroll',
      }, 
    }
  });
});

// Heliumのメルマガチェック時、newsletterに何もチェックが入っていない場合、ウィメンズに自動チェック
document.addEventListener('cf:ready', function () {
  const $form = document.querySelector('form[data-cf-form="bbtvqp"]');
  if (!$form) return;
  
  const marketingConsent = $form.querySelector('input[data-cf-column-key="email_marketing_consent"]');
  const womensCheckbox = $form.querySelector('input[data-cf-column-key="newsletter"][value="womens"]');
  const mensCheckbox = $form.querySelector('input[data-cf-column-key="newsletter"][value="mens"]');
  
  if (!marketingConsent || !womensCheckbox || !mensCheckbox) return;
  
  // マーケティング同意チェックボックスの変更を監視
  marketingConsent.addEventListener("change", function () {
    if (this.checked) {
      // どちらのニュースレターも選択されていない場合、ウィメンズを自動選択
      if (!womensCheckbox.checked && !mensCheckbox.checked) {
        womensCheckbox.click();
      }
    }
  });
});